import React from 'react';
import { connect } from 'react-redux';
import { hideModal, showModal } from '../../modalsSlice';
import SubscriptionOptionsModal from './SubscriptionOptionsModal';
import { Props } from './types';
import { RootState } from '../../../../app/store';
import { getMSISDN } from '../../../auth/selectors';

const SubscriptionOptionsModalContainer: React.FC<Props> = (props) => (
  <SubscriptionOptionsModal {...props} />
);

const mapStateToProps = (state: RootState) => ({
  msisdn: getMSISDN(state),
});

const dispatchProps = {
  hideModal,
  showModal,
};

export default connect(mapStateToProps, dispatchProps)(SubscriptionOptionsModalContainer);
